"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PetParentNotificationEvent = void 0;
var PetParentNotificationEvent;
(function (PetParentNotificationEvent) {
    PetParentNotificationEvent["RemovedFromChannel"] = "RemovedFromChannel";
    PetParentNotificationEvent["AddedToChannel"] = "AddedToChannel";
})(PetParentNotificationEvent = exports.PetParentNotificationEvent || (exports.PetParentNotificationEvent = {}));
//# sourceMappingURL=SendPetParentNotificationJobInput.js.map